module.exports = __webpack_public_path__ + "static/media/ahmed.b0d2e633.jpeg";